import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../../config';
import { requestSchema as PostInsuranceCompaniesReconciliationReportRequestSchema } from './post-insurance-companies-reconciliation';

const requestSchema = z.object({
	searchCriteria: PostInsuranceCompaniesReconciliationReportRequestSchema.omit({ paging: true, sorting: true }),
	settlementDate: z.string().optional(),
	settlementReferenceNo: z.string().optional(),
});

const responseSchema = z.void();

const postICProductionMarkAsSettled = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/report/ic-recon-new/markAsSettled',
		method: 'POST',
		responseSchema,
		requestSchema,
	});

export type PostICProductionMarkAsSettledRequest = z.infer<typeof requestSchema>;

export type PostICProductionMarkAsSettledResponse = TypeOfAPIResponse<ReturnType<typeof postICProductionMarkAsSettled>>;

export type PostICProductionMarkAsSettledError = TypeOfAPIError<ReturnType<typeof postICProductionMarkAsSettled>>;

export default postICProductionMarkAsSettled;
